import { render, staticRenderFns } from "./SpellOrder.vue?vue&type=template&id=8068d65e&scoped=true"
import script from "./SpellOrder.vue?vue&type=script&lang=js"
export * from "./SpellOrder.vue?vue&type=script&lang=js"
import style0 from "./SpellOrder.vue?vue&type=style&index=0&id=8068d65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8068d65e",
  null
  
)

export default component.exports